<template>
  <v-container>

    <v-row class="text-center">
      <v-col cols="12">
        <div class="logo">
        <v-img
          :src="require('../assets/logo.png')"
          class="my-3"
          contain
          height="150"
        />
        </div>
      </v-col>

      <v-col class="mb-4 text-center">
        <v-row cols="12" justify="center">
          <div>
            <h1 class="chainovate-headline text-center mb-3">
              CHAINOVATE
            </h1>
          </div>
        </v-row>

        <p class="chainovate-subheading">
          strive for perfection <br v-if="windowwidth<490">and create experiences
        </p>
      </v-col>

        <v-col
          class="mb-5"
          cols="12"
        >
          <v-row justify="center">   
            <v-col
              cols="12"
              xs="12"
              md="4"
            >
              <div class="card-border-gradient-right"></div>
              <div v-bind:class="{ servicecard:true, roundedleft:windowwidth>959 }">
                <p class="card-headline">E-Commerce</p>
                <p class="card-detail">scalable webshops</p>
                <p class="card-detail">blockchain gateways</p>
                <p class="card-detail">individual integrations</p>
              </div>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              md="4"
            >
              <div v-bind:class="{ servicecard:true, elevatedhigher:true, roundedboth:windowwidth>959}">
                <p class="card-headline">High-Performance Websites</p>
                <v-spacer/>
                <p class="card-detail">complex interactive webapps</p>
                <p class="card-detail">custom backoffice solutions</p>
                <p class="card-detail">breathtaking landing pages</p>
                <p class="card-detail">private hosting</p>
              </div>
            </v-col>
            <v-col
              cols="12"
              xs="12"
              md="4"
            >
              <div class="card-border-gradient-left"></div>
              <div v-bind:class="{servicecard:true, roundedright:windowwidth>959}">
                <p class="card-headline">Design and Media</p>
                <p class="card-detail">custom logo and brand identity</p>
                <p class="card-detail">corporate design and documents</p>
                <p class="card-detail">modern user experience</p>
              </div>
            </v-col>
            <div class="bm"></div>
          </v-row>
        </v-col>

      <a href="mailto:info@chainovate.com" class="chainovate-email chainovate-subheading">
          info@chainovate.com
        </a>

      <v-dialog
        v-model="dialog"
        width="500"
      >
        <template v-slot:activator="{ on }">
          <div class="footer chainovate-subheading">
            <div>website is under construction | <br v-if="windowwidth<640">view our <a v-on="on">legal notice</a></div>
          </div>
        </template>

        <v-card class="roundedboth">
          <v-card-title
            class="headline grey lighten-2 pr-2 pl-2"
            primary-title
          >
            <v-spacer/>
            <span class="chainovate-headline text-center legal-notice-text">
              LEGAL NOTICE
            </span>
            <v-spacer/>
          </v-card-title>

          <v-card-text class="text-center">
            <br>
            <br>
            <span>
              <p class="card-detail">Chainovate LTD.</p>
            </span>
            <span>
              <p class="card-detail">Company Number: 11599925</p>
            </span>
            <br>
            <span>
              <p>Companyplanet Unit</p>
              <p>50 Salisbury Road Hounslow,</p>
              <p>Greater London United Kingdom</p>
              <p>TW4 6JQ</p>
            </span>
            <br>
            <span>
              <p>info@chainovate.com</p>
            </span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer/>
            <a
              @click="dialog = false"
            >
              close info
            </a>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Home',
    meta: {title: 'Home'},
    data: () => ({
      dialog: false,
      windowwidth: 0,
    }),
    created() {
      window.addEventListener("resize", this.onResizeDetected)
      this.windowwidth = this.windowwidth = window.innerWidth
    },
    destroyed() {
      window.removeEventListener("resize", this.onResizeDetected)
    },
    methods: {
      onResizeDetected() {
        this.windowwidth = window.innerWidth
      }
    }
  }
</script>

<style lang="scss">
.logo {
  margin-top: 70px;
  margin-bottom: 10px;
}
.chainovate-headline {
  letter-spacing: 1.1em;
  font-weight: 300 !important;
  margin-right: -1.1em;
  color: #333;

  @media only screen and (max-width : 640px) {
    font-size: 1.8em;
  }
  @media only screen and (max-width : 590px) {
    letter-spacing: 0.9em;
    margin-right: -0.9em;
  }
  @media only screen and (max-width : 465px) {
    letter-spacing: 0.8em;
    margin-right: -0.8em;
  }
  @media only screen and (max-width : 430px) {
    letter-spacing: 0.7em;
    margin-right: -0.7em;
  }
  @media only screen and (max-width : 395px) {
    letter-spacing: 0.6em;
    margin-right: -0.6em;
  }
}
.chainovate-subheading {
  letter-spacing: 0.2em;
  font-weight: 300 !important;
  margin-right: -0.2em;
  color: #666;
}

.card-border-gradient-left {
  height: 5px;
  background: rgba(253,197,49,1);
  background: -moz-linear-gradient(left, rgba(253,197,49,1) 0%, rgba(241,130,28,0.9) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgba(253,197,49,1)), color-stop(100%, rgba(241,130,28,0.9)));
  background: -webkit-linear-gradient(left, rgba(253,197,49,1) 0%, rgba(241,130,28,0.9) 100%);
  background: -o-linear-gradient(left, rgba(253,197,49,1) 0%, rgba(241,130,28,0.9) 100%);
  background: -ms-linear-gradient(left, rgba(253,197,49,1) 0%, rgba(241,130,28,0.9) 100%);
  background: linear-gradient(to right, rgba(253,197,49,1) 0%, rgba(241,130,28,0.9) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fdc531', endColorstr='#f1821c', GradientType=1 );
}
.card-border-gradient-right {
  height: 5px;
  background: rgba(241,131,28,1);
  background: -moz-linear-gradient(left, rgba(241,131,28,0.9) 0%, rgba(253,198,49,1) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgba(241,131,28,0.9)), color-stop(100%, rgba(253,198,49,1)));
  background: -webkit-linear-gradient(left, rgba(241,131,28,0.9) 0%, rgba(253,198,49,1) 100%);
  background: -o-linear-gradient(left, rgba(241,131,28,0.9) 0%, rgba(253,198,49,1) 100%);
  background: -ms-linear-gradient(left, rgba(241,131,28,0.9) 0%, rgba(253,198,49,1) 100%);
  background: linear-gradient(to right, rgba(241,131,28,0.9) 0%, rgba(253,198,49,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f1831c', endColorstr='#fdc631', GradientType=1 );
}
.servicecard {
  background-color: white;
  padding: 16px 16px 16px 16px;
  font-weight: 300 !important;
  -webkit-box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 5px 18px 0px rgba(0, 0, 0, 0.07);

  @media only screen and (max-width : 640px) {
    padding: 15px 15px 8px 15px;
  }

  &.elevatedhigher {
    -webkit-box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.09);
    -moz-box-shadow: 0px 2px 18px 0px rgba(0, 0, 0, 0.09);
    box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.08);
    border-top: solid 5px #fdc531;
  }

  & .card-headline {
    font-weight: 300 !important;
    font-size: 18px;
    letter-spacing: 0.15em;
    margin-right: -0.15em;
    padding-bottom: 12px;
    border-bottom: solid 1px rgba(0,0,0,0.03);
    min-height: 100;
    color: #333;
  }
  & .card-detail {
    color: #444;
  }
  &.roundedleft {
    border-radius: 0 0 0 25px;
  }
  &.roundedright {
    border-radius: 0 0 25px 0;
  }
  &.roundedboth {
    border-radius: 0 0 25px 25px;
  }
}

.chainovate-email {
  position: absolute;
  top: 0;
  right: 0;
  margin: 15px;
  margin-right: 17px;
  text-decoration: none;
  color: #444 !important;
}

.footer {
  position: absolute;
  left: 0;
  bottom: 0;
  border-top: solid 1px #f5f5f5;
  border-top: solid 1px rgba(0,0,0,0.03);
  width: 100%;
  padding: 5px;
  font-size: 12px;
  float: right !important;
  color: #555;

  @media only screen and (max-width : 640px) {
    padding: 15px;
    background-color: #fff; 
  }
  
  & a {
    color: #444 !important;
    text-decoration: underline;
    text-decoration-color: #bbb !important;
  }
}

a {
    color: #666 !important;
    text-decoration: underline;
    text-decoration-color: #bbb !important;
}

.bm {
  height: 0;
  @media only screen and (max-width : 640px) {
    height: 310px;
  }
}

.legal-notice-text {
  font-size: 1em;
  letter-spacing: 0.6em;
    margin-right: -0.6em;
  @media only screen and (max-width : 640px) {
    font-size: 1em;
    letter-spacing: 0.4em;
    margin-right: -0.4em;
  }
}
</style>